import React, { Component } from 'react'
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Button,
  Label,
  Input,
  InputGroup,
  InputGroupButton,
  Form
} from 'reactstrap'

import { Prompt } from 'react-router-dom'
import EditableCard from '../../components/EditableCard'
import Auth from '../../modules/Auth'
import { get } from '../../modules/API'

class Events extends Component {
  constructor(props) {
    super(props)

    this.state = {
      count: 0,
      next: null,
      previous: null,
      events: [],
      addEvent: false,
      editingMode: false,
      loaded: false
    }

    this.setEditingMode = this.setEditingMode.bind(this)
    this.addEvent = this.addEvent.bind(this)
    this.showAddEvent = this.showAddEvent.bind(this)
    this.cancelAddEvent = this.cancelAddEvent.bind(this)
    this.deleteEvent = this.deleteEvent.bind(this)
    this.updateModel = this.updateModel.bind(this)
    this.searchEvent = this.searchEvent.bind(this)
  }

  componentDidMount() {
    if (Auth.isUserAuthenticated()) {
      get(`events?manager_id=${this.props.userInfo.id}&order_by=-start_date`)
        .then(data => {
          this.setState({
            loaded: true,
            ...data,
            results: null,
            events: data.results,
            isSearchable: data.results.length > 5
          })
        })
    }
  }

  searchEvent(ev) {
    ev.preventDefault()

    let searchTerm = this.search.value

    get(`events?manager_id=${this.props.userInfo.id}&name__contains=${searchTerm}&order_by=-start_date`)
    .then(data => {
      this.setState({
        ...data,
        results: null,
        events: data.results
      })
    })
  }

  setEditingMode(editingMode) {
    this.setState({ editingMode })
  }

  addEvent(event) {
    this.setState(prevState => {
      const events = prevState.events.concat(event)
      return {
        events,
        addEvent: false,
        isSearchable: events.length > 5
      }
    })
  }

  showAddEvent() {
    this.setState({ addEvent: true })
  }

  cancelAddEvent() {
    this.setState({ addEvent: false })
  }

  deleteEvent(id) {
    this.setState(prevState => {
      const events = prevState.events.filter(el => el.id !== id)
      return {
        events,
        isSearchable: events.length > 5
      }
    })
  }

  updateModel(model, data) {
    this.setState(prevState => {
      let newData = prevState[model].map(el => {
          if (el.id === data.id) {
            return data
          } else {
            return el
          }
        })

      return {
        [model]: newData
      }
    })
  }

  render() {
    const events_cards = this.state.events.map((event, index) => {
      let cardFields = [
          {
            id: 'picture',
            fieldType: 'single_image',
            fieldValue: event.picture,
            fieldLabel: 'Bild zum Termin',
            imageAspectRatio: 1
          }, {
            id: 'name',
            fieldType: 'text',
            fieldValue: event.name,
            fieldLabel: 'Titel des Termins',
            fieldClassName: 'hidden-view-mode',
            fieldRequired: true,
            fieldCharLimit: 64
          }, {
            id: 'location',
            fieldType: 'text',
            fieldValue: event.location,
            fieldLabel: 'Adresse & Ort',
            fieldRequired: true
          }
        ]

      if (this.props.userProfiles.length > 1) {
        cardFields = cardFields.concat({
          id: 'sales_profile_id',
          fieldType: 'select',
          fieldValue: event.sales_profile_id,
          fieldValues: this.props.userProfiles.map(el => {
            return {
              id: el.id,
              value: el.office_name
            }
          }),
          fieldLabel: 'Verantwortliches Büro',
          fieldIsDisabled: true
        })
      }

      cardFields = cardFields.concat([
        {
          id: 'start_date',
          fieldType: 'date',
          fieldValue: event.start_date,
          fieldLabel: 'Datum - Start',
          fieldClassName: 'events-date-start',
          fieldRequired: true
        }, {
          id: 'end_date',
          fieldType: 'date',
          fieldValue: event.end_date,
          fieldClassName: 'events-date-end',
          fieldLabel: 'Datum - Ende'
        }, {
          id: 'start_time',
          fieldType: 'time',
          fieldValue: event.start_time,
          fieldLabel: 'Zeit - Start',
          fieldClassName: 'events-time-start',
          fieldRequired: true
        }, {
          id: 'end_time',
          fieldType: 'time',
          fieldValue: event.end_time,
          fieldLabel: 'Zeit - Ende',
          fieldClassName: 'events-time-end',
          fieldRequired: true
        }, {
          id: 'description',
          fieldType: 'textarea',
          fieldValue: event.description,
          fieldLabel: 'Beschreibung des Termins',
          fieldClassName: 'events-description',
          textareaPlaceholder: 'Geben Sie Interessenten weitere wichtige Details zu der Veranstaltung',
          textareaRows: 5,
          fieldRequired: true
        }
      ])

      return {
        id: event.id,
        cardTitle: event.name,
        cardTemplate: 'event',
        fetchData: {
          method: 'patch',
          endpoint: this.props.userProfiles.length > 1 ? `sales-profiles/sales_profile_id/events/${event.id}` : `sales-profiles/${this.props.userProfiles[0].id}/events/${event.id}`,
          endpointOptions: {
            isDynamic: this.props.userProfiles.length > 1,
            field: 'sales_profile_id'
          }
        },
        cardFields
      }
    })

    let cardFields = [
        {
          id: 'picture',
          fieldType: 'single_image',
          fieldLabel: 'Bild zum Termin',
          imageAspectRatio: 1
        }, {
          id: 'name',
          fieldType: 'text',
          fieldLabel: 'Titel des Termins',
          fieldCharLimit: 64,
          fieldRequired: true
        }, {
          id: 'location',
          fieldType: 'text',
          fieldLabel: 'Adresse & Ort',
          fieldRequired: true
        }
      ]

    if (this.props.userProfiles.length > 1) {
      cardFields = cardFields.concat({
        id: 'sales_profile_id',
        fieldType: 'select',
        fieldValues: this.props.userProfiles.map(el => {
          return {
            id: el.id,
            value: el.office_name
          }
        }),
        fieldLabel: 'Verantwortliches Büro',
        fieldRequired: true
      })
    }

    cardFields = cardFields.concat([
      {
        id: 'start_date',
        fieldType: 'date',
        fieldLabel: 'Datum - Start',
        fieldRequired: true
      }, {
        id: 'end_date',
        fieldType: 'date',
        fieldLabel: 'Datum - Ende'
      }, {
        id: 'start_time',
        fieldType: 'time',
        fieldLabel: 'Zeit - Start',
        fieldRequired: true
      }, {
        id: 'end_time',
        fieldType: 'time',
        fieldLabel: 'Zeit - Ende',
        fieldRequired: true
      }, {
        id: 'description',
        fieldType: 'textarea',
        fieldLabel: 'Beschreibung des Termins',
        textareaPlaceholder: 'Geben Sie Interessenten weitere wichtige Details zu der Veranstaltung',
        textareaRows: 5,
        fieldRequired: true
      }
    ])

    const events_card_blank = {
        cardTitle: 'Termin',
        fetchData: {
          method: 'post',
          endpoint: this.props.userProfiles.length > 1 ? `sales-profiles/sales_profile_id/events` : `sales-profiles/${this.props.userProfiles[0].id}/events`,
          endpointOptions: {
            isDynamic: this.props.userProfiles.length > 1,
            field: 'sales_profile_id'
          }
        },
        cardFields
      }

    let addEventBlock = this.state.addEvent &&
      <EditableCard
        userInfo={this.props.userInfo}
        {...events_card_blank}
        getEditingMode={this.state.editingMode}
        setEditingMode={this.setEditingMode}
        newCard={true}
        addEvent={this.addEvent}
        cancelAddEvent={this.cancelAddEvent}
      />

    let searchBox = this.state.isSearchable &&
      <Row>
        <Col className="mb-4">
          <Form onSubmit={this.searchEvent}>
            <Label for="search">Termin finden</Label>
            <InputGroup>
              <Input type="text" id="search" placeholder="Titel des Termins" innerRef={el => this['search'] = el} />
              <InputGroupButton>
                <Button color="primary" type="submit"><i className="icon-magnifier"></i></Button>
              </InputGroupButton>
            </InputGroup>
          </Form>
        </Col>
      </Row>

    return this.state.loaded && (
      <div className="animated fadeIn">
        <Prompt
            when={this.state.editingMode}
            message={`Änderungen verwerfen?`}
          />
        <Row>
          <Col>
            <h2>Termine</h2>
            <Button color="primary" className="mb-3" onClick={this.showAddEvent}>Neuen Termin erstellen</Button>
            {addEventBlock}
            {searchBox}
            {events_cards.length > 0 && events_cards.map(el => {
              return <EditableCard
                userInfo={this.props.userInfo}
                key={`event_card_${el.id}`}
                id={el.id}
                {...el}
                getEditingMode={this.state.editingMode}
                setEditingMode={this.setEditingMode}
                isDeletable={true}
                deleteEvent={this.deleteEvent}
                updateModel={this.updateModel}
              />})
            }
          </Col>
        </Row>
      </div>
    )
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/views/Events/Events.js